// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import LoadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrderByOrderNumber";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import cloneDeep from "lodash/cloneDeep";

export const LoadInventory: typeof RequestDataFromApi = async props => {
    const state = props.getState();
    const isOrderDetailsPage = getCurrentPage(state).type === "OrderDetailsPage";
    if (
        !props.apiResult ||
        !props.apiResult.orderLines ||
        props.apiResult.orderLines.length === 0 ||
        !isOrderDetailsPage
    ) {
        return;
    }

    let apiResultwithInventory = cloneDeep(props.apiResult);

    props.dispatch(
        LoadRealTimeInventory({
            productIds: apiResultwithInventory.orderLines!.map(p => p.productId || "").filter(Boolean),
            onSuccess: result => {
                result.realTimeInventoryResults?.forEach(inventory => {
                    apiResultwithInventory.orderLines!.map(line => {
                        if (line?.productId === inventory.productId) {
                            (line as any).inventory = inventory;
                        }
                        delete (line as any).failedToLoadInventory;
                        return line;
                    });
                });

                props.dispatch({
                    type: "Data/Orders/CompleteLoadOrder",
                    model: apiResultwithInventory,
                });
            },
            onError: result => {
                apiResultwithInventory.orderLines?.every(({ line }: any) => {
                    if (line) {
                        line.failedToLoadInventory = true;
                        line.inventory = null;
                    }
                    return line;
                });
                props.dispatch({
                    type: "Data/Orders/CompleteLoadOrder",
                    model: apiResultwithInventory,
                });
            },
        }),
    );
};

addToChainAfter(chain, RequestDataFromApi, LoadInventory);
